import React from 'react';
import { Icon } from '@iconify/react';


export function ModuleOverview() {

    return (
        
            <div className="Icons">

                <div className="Arrow-Icon">
                    <Icon icon="material-symbols:arrow-drop-down" color="black" width="21" height="21" />
                </div>

                <div className="Pencil-Icon">
                    <Icon icon="akar-icons:pencil" color="black" width="21" height="21" />
                </div>

                <div className="Module-Icon">
                    <Icon icon="material-symbols:crop-square-outline" color="red" />
                </div>
                <div className="ModuleDescription1">IT Projektseminar</div>
                <hr className="hline0" />

                <div className="Clock-Icon">
                    <Icon icon="mdi:clock-time-four-outline" color="black" width="21" height="21" />
                </div>
                <div className="TimeDescription1">Mittwoch, 24. Oktober</div>
                <div className="HourDescription1">09:00</div>
                <div className="TimeDescription2">Mittwoch, 24. Oktober</div>
                <div className="HourDescription2">12:15</div>

                <div className="LoopCircular-Icon">
                <Icon icon="ic:baseline-refresh" color="black" width="21" height="21" />
                </div>
                <div className="TimeDescription3">Wöchentlich</div>
                <hr className="hline1" />

                <div className="Prof-Icon">
                    <Icon icon="mdi:user-outline" color="black" width="21" height="21" />
                </div>
                <div className="ProfDescription1">Hinz</div>
                <hr className="hline2" />

                <div className="Room-Icon">
                    <Icon icon="material-symbols:meeting-room-outline" color="black" width="21" height="21" />
                </div>
                <div className="RoomDescription1">R 0.005</div>
                <hr className="hline3" />

                <div className="OnlineMeeting-Icon">
                    <Icon icon="material-symbols:camera-outdoor-outline" color="black" width="21" height="21" />
                </div>
                <div className="OnlineRoomDescription1">Zoom nicht verfügbar</div>
                <hr className="hline4" />
            </div> 
        

    );
}